import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import _find from 'lodash/find';

export default create()(
  immer((set) => ({
    entityOpen: false,
    selectedEntityPetavueIndex: null,
    selectedColumnName: null,
    selectedColumnLabel: null,
    resultName: null,
    entityMeta: {},
    entityRowIndex: null,
    focusId: null,
    focusIdForScroll: null,
    arrowClicked: false,
    actualWidgets: [],
    setEntityOpen: (entityOpen) =>
      set((state) => {
        state.entityOpen = entityOpen;
      }),
    setSelectedEntityPetavueIndex: (selectedEntityPetavueIndex) =>
      set((state) => {
        state.selectedEntityPetavueIndex = selectedEntityPetavueIndex;
      }),
    setSelectedColumnName: (selectedColumnName) =>
      set((state) => {
        state.selectedColumnName = selectedColumnName;
      }),
    setSelectedColumnLabel: (selectedColumnLabel) =>
      set((state) => {
        state.selectedColumnLabel = selectedColumnLabel;
      }),
    setEntityMeta: (data) =>
      set((state) => {
        state.entityMeta = data;
      }),
    setSelectedEntityRowIndex: (entityRowIndex) =>
      set((state) => {
        state.entityRowIndex = entityRowIndex;
      }),
    setFocusId: (focusId) =>
      set((state) => {
        state.focusId = focusId;
      }),
    setFocusIdForScroll: (focusIdForScroll) =>
      set((state) => {
        state.focusIdForScroll = focusIdForScroll;
      }),
    setArrowClicked: (arrowClicked) =>
      set((state) => {
        state.arrowClicked = arrowClicked;
      }),
    setActualWidgets: (actualWidgets) =>
      set((state) => {
        state.actualWidgets = actualWidgets;
      }),
    resetToDefaults: () => {
      set((state) => {
        state.entityOpen = false;
        state.selectedEntityPetavueIndex = null;
        state.selectedColumnName = null;
        state.selectedColumnLabel = null;
        state.entityMeta = {};
        state.entityRowIndex = null;
        state.focusId = null;
        state.arrowClicked = false;
        state.actualWidgets = [];
      });
    },
  }))
);
